const useStyles = (theme) => ({});

export default useStyles;
